import { toast } from 'react-toastify';
import api from 'services/api';
import {
  ConsumptionHistoryData,
  GetConsumptionHistoryProps,
  GetConsumptionDetailsProps,
  GetConsumptionDetailsData,
  InstallmentsData,
} from '../types';

export const getConsumptionHistory = async ({
  initialDate,
  finalDate,
  monthType,
  currentPage,
  exportExcel = false,
}: GetConsumptionHistoryProps): Promise<ConsumptionHistoryData[]> => {
  const baseUrl = 'industrial/invoice/v1/invoices/consumption-history?';

  const paramExportExcel = exportExcel ? '&export-excel=true' : '';
  const customerCode = localStorage.getItem(
    '@UltragazEmpresarial:customerCode'
  );
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );
  const accessToken = localStorage.getItem('@UltragazEmpresarial:accessToken');

  const params = `customer-site-code=${customerSiteCode}&customer-code=${customerCode}&begin-date=${initialDate}&end-date=${finalDate}&_monthly=${monthType}&_limit=10000&_offset=${currentPage}${paramExportExcel}`;

  const header = {
    'Content-Type': 'application/json',
    access_token: accessToken,
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  const parameters = {
    headers: header,
    ...(exportExcel && {
      method: 'POST',
      responseType: 'blob',
    }),
  };

  const { data } = await api.get(
    `${baseUrl}${params}`,
    // @ts-ignore
    parameters
  );

  if (exportExcel) {
    const urlDownload = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = urlDownload;
    link.setAttribute('download', `historico_de_consumo.xlsx`);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
  }
  return data;
};

export const getConsumptionDetails = async ({
  initialDate,
  finalDate,
}: GetConsumptionDetailsProps): Promise<GetConsumptionDetailsData[]> => {
  const baseUrl = 'industrial/invoice/v1/invoices?';
  const customerCode = localStorage.getItem(
    '@UltragazEmpresarial:customerCode'
  );
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );
  const accessToken = localStorage.getItem('@UltragazEmpresarial:accessToken');

  const headers = {
    'Content-Type': 'application/json',
    access_token: accessToken,
  };

  const params = `customer-site-code=${customerSiteCode}&customer-code=${customerCode}&typeable-line=NOT_NULL&_expand=installments,consumption&begin-date=${initialDate}&end-date=${finalDate}&_limit=1000000&_offset=0`;

  const { data } = await api.get<GetConsumptionDetailsData[]>(
    `${baseUrl}${params}`,
    { headers }
  );
  return data;
};

type BankSlipsFormatedData = {
  invoice: GetConsumptionDetailsData;
  installment?: InstallmentsData;
};

interface GetBankslipForDownloadProp extends BankSlipsFormatedData {
  deliveryMethod?: string;
}

export const getBankslipForDownload = async ({
  invoice,
  installment,
  deliveryMethod = 'DOWNLOAD',
}: GetBankslipForDownloadProp): Promise<string | void> => {
  const baseUrl = `industrial/invoice/v1/invoices/${invoice?.invoiceId}/installments/${installment?.installmentId}/bankslips`;

  const contactIdSf = localStorage.getItem('@UltragazEmpresarial:contactIdSf');
  const email = localStorage.getItem('@UltragazEmpresarial:loginEmail');
  const customerCode = localStorage.getItem(
    '@UltragazEmpresarial:customerCode'
  );
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );
  const accessToken = localStorage.getItem('@UltragazEmpresarial:accessToken');

  const header = {
    'Content-Type': 'application/json',
    access_token: accessToken,
  };

  const body = {
    customerCode,
    customerSiteCode,
    deliveryMethod: deliveryMethod ?? 'DOWNLOAD',
    ...(contactIdSf && { contactIdSf }),
    ...(deliveryMethod === 'EMAIL' && { email }),
  };

  const parameters = {
    method: 'POST',
    headers: header,
    ...(deliveryMethod === 'DOWNLOAD' && { responseType: 'blob' }),
  };

  // @ts-ignore
  const { data } = await api.post(baseUrl, body, parameters);
  if (deliveryMethod === 'EMAIL') {
    toast.success(`Boleto enviado para o e-mail: ${email}`);
  } else {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${installment?.installmentId}.pdf`);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
  }
};
